var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentCenter.enable_sbt
    ? _c(
        "div",
        {
          staticClass: "flex",
          attrs: { id: "repository-skill-based-treatment-base" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky left-0 z-40 flex-shrink-0 overflow-y-auto border-r top-18 w-60 bg-pure-white border-slate-400",
              style: { height: "calc(100vh - 4.5rem)" },
              attrs: { id: "repository-skill-based-treatment-tabs" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "sticky top-0 z-10 flex items-center px-6 py-6 border-b bg-pure-white border-slate-400"
                },
                [
                  _c("BlTextTitle3", {
                    attrs: { text: "Skill-Based Treatments" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col gap-1 px-3 py-1" },
                _vm._l(_vm.tabs, function(tab, idx) {
                  return _c(
                    "div",
                    { key: idx },
                    [
                      tab.divider
                        ? _c("div", {
                            staticClass: "h-0.5 w-full bg-slate-300"
                          })
                        : _c(
                            "router-link",
                            {
                              staticClass:
                                "relative flex items-center h-12 gap-2 px-3 transition-all duration-300 rounded",
                              class: [
                                tab.isActive
                                  ? "bg-slate-300"
                                  : "hover:bg-hover-state"
                              ],
                              attrs: { to: tab.target }
                            },
                            [
                              _c("BlTextSubtitle3", {
                                attrs: { text: tab.label }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex flex-col flex-grow",
              attrs: { id: "repository-skill-based-treatment-body" }
            },
            [
              !_vm.searchParams["tab"] ? _c("Prompting") : _vm._e(),
              _vm._v(" "),
              _vm.searchParams["tab"] === "tasks-codes"
                ? _c("TasksCodes")
                : _vm._e(),
              _vm._v(" "),
              _vm.searchParams["tab"] === "problem-behaviors"
                ? _c("ProblemBehavior")
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _c(
        "div",
        { staticClass: "flex items-center justify-center w-full h-screen" },
        [
          _c("BlTextBody1", {
            attrs: {
              text: "This center does not enable Skill-Based Treatment."
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18ffc9b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18ffc9b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/Sbt.vue
// module id = null
// module chunks = 